/*
 * @Descripttion: create file
 * @Author: zhangtingjiang
 * @Date: 2021-04-15 12:28:43
 */
import Vue from 'vue'
import Router from 'vue-router'
Vue.use(Router)

const router = new Router({
  mode: 'history',
  scrollBehavior: () => ({ y: 0 }),
  routes: [
    {
      path: '/application',
      name: 'application',
      component: resolve => require(['../views/Application.vue'], resolve),
      children: [
        {
          path: '/introduction',
          name: 'introduction',
          component: resolve => require(['../views/Introduction/Introduction.vue'], resolve)
        },
        {
          path: '/result/:type',
          name: 'result',
          component: () => import('@/views/Result/index.vue')
        },
        {
          path: '/single/index',
          name: 'index',
          component: () => import('@/views/SingleApply/SingleApply.vue')
        },
        {
          path: '/provincialInformation',
          name: 'index',
          component: () => import('@/views/GroupApply/ProvincialInformation.vue')
        },
        {
          path: '/judgesToSignUpInfo',
          name: 'index',
          component: () => import('@/views/GroupApply/JudgesToSignUpInfo.vue')
        },
        {
          path: '/judgesToDeclare/index',
          name: 'index',
          component: () => import('@/views/judgesToDeclare/SingleApply.vue')
        },
        {
          path: '/judgesToDeclare/edit',
          name: 'index',
          component: () => import('@/views/judgesToDeclareEdit/SingleApply.vue')
        },
        {
          path: '/enroll',
          name: '报名页',
          component: resolve => require(['@/views/GroupApply/GroupApply.vue'], resolve)
        },
        {
          path: '/addPlayer',
          name: 'addPlayer',
          component: () => import('@/views/EnrollDetail/AddPlayer.vue')
        },
        {
          path: '/addLeader',
          name: 'addLeader',
          component: () => import('@/views/AddLeader/AddLeader.vue')
        },
        {
          path: 'update-password',
          name: 'applicationUpdatePassword',
          component: () => import('@/views/ApplicationUpdatePassword.vue')
        },
        {
          path: '/result/:status',
          name: 'finish',
          component: resolve => require(['../views/FinishApply.vue'], resolve)
        }
      ]
    },
    // 组队报名入口登录之后强制更新密码
    {
      path: '/:activity_id/update-password',
      name: 'updatePassword',
      component: () => import('@/views/Login/UpdatePassword.vue')
    },
    {
      path: '/:activity_id',
      name: 'login',
      component: resolve => require(['../views/Login/index.vue'], resolve)
    },
    {
      path: '/:activity_id/:apply',
      name: 'login',
      component: resolve => require(['../views/Login/index.vue'], resolve)
    },
    {
      path: '*',
      name: 'notFound',
      component: resolve => require(['../views/NotFound.vue'], resolve)
    }
  ]
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js